import { useTranslation } from 'react-i18next';
import klaxAuthHeroBg from 'assets/images/klax-auth-hero-bg.jpg';
import klaxLogoVector from 'assets/images/Vector.svg';
import klaxTagline from 'assets/images/Business AI. Simplified..svg';
import klaxPointingHand from 'assets/images/easy 2.svg';
import { cn } from 'lib/utils';

type KlaxAuthHeroProps = {
  className?: string;
};

export function KlaxAuthHero({ className }: KlaxAuthHeroProps) {
  const { t } = useTranslation();

  return (
    <div className={cn('relative h-full w-full shrink-0 overflow-hidden', className)}>
      <div aria-hidden className="pointer-events-none absolute inset-0">
        <div
          className="absolute inset-0 overflow-hidden backdrop-blur-[50px]"
          style={{
            background: `linear-gradient(0deg, rgba(0, 0, 0, 0.80) 0%, rgba(0, 0, 0, 0.00) 100%), url(${klaxAuthHeroBg}) center top/cover no-repeat`,
          }}
        />
      </div>

      <div className="absolute left-6 top-8 z-10 flex w-[min(100%,250px)] flex-col xl:left-12 xl:top-10 xl:w-[250.557px]">
        <img
          src={klaxLogoVector}
          alt="KLAX!"
          width={250.557}
          height={79.863}
          className="h-auto w-full max-w-[200px] object-contain object-left-top xl:h-20 xl:w-[250.557px]"
        />
        <img
          src={klaxTagline}
          alt={t('BUSINESS_AI_SIMPLIFIED')}
          width={250.031}
          height={21.536}
          className="mt-3 h-auto w-full max-w-[200px] object-contain object-left-top xl:mt-4 xl:h-5 xl:w-[250.031px]"
        />
      </div>

      <div className="absolute bottom-6 left-0 right-0 z-10 flex justify-center px-6 xl:bottom-8">
        <div className="relative w-full max-w-[635px]">
          <div
            className="absolute -left-2 -top-14 size-16 shrink-0 xl:-left-4 xl:-top-[85px] xl:size-[104px]"
            aria-hidden
          >
            <div className="absolute inset-x-[1.9%] inset-y-0">
              <img src={klaxPointingHand} alt="" className="block size-full max-w-none" />
            </div>
          </div>

          <div className="flex flex-col items-center gap-4 text-center">
            <h2 className="w-full max-w-[547px] text-2xl font-semibold leading-display text-true-white xl:text-hero">
              {t('AUTH_TAGLINE', 'Let Agents do the work for you.')}
            </h2>
            <p className="w-full max-w-[409px] text-sm font-normal leading-body text-grey-200 xl:text-lg">
              {t('AUTH_TAGLINE_DESCRIPTION', 'Your AI teammates handle emails, tasks, and follow-ups automatically.')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
